module.exports = __webpack_public_path__ + "img/key_features--accessories.8f7a6482.png";